import MedicalServicesOutlined from '@mui/icons-material/MedicalServicesOutlined'

import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import Section from '@components/Details/Section'

import Field from './Field'

const SERVICES = [
  { key: 'hepCScreenAndTreat', label: 'Hep C screen & treat' },
  { key: 'longitudinalHIVCare', label: 'Longitudinal HIV Care' },
  { key: 'inPersonHealthCenter', label: 'In person clinic/health center' },
  { key: 'labsInPerson', label: 'Labs & lab results in person' },
  { key: 'behaviorHealth', label: 'Behavior Health' },
  { key: 'mentalHealth', label: 'Mental Health' },
  { key: 'housing', label: 'Housing' },
  { key: 'foodInsecurity', label: 'Nutrition & Food Insecurity' },
]

export default function Services({ data, isLoading }) {
  return (
    <Section title="Services Offered at CBO" icon={<MedicalServicesOutlined />}>
      <Stack sx={{ gap: 1 }}>
        {SERVICES.map(({ key, label }) => (
          <Field key={key} label={label} isLoading={isLoading} value={<Service service={data?.additionalServices?.[key]} />} />
        ))}
      </Stack>
    </Section>
  )
}

function Service({ service }) {
  return (
    <Stack direction="row" sx={{ gap: 2, minWidth: 0 }}>
      <Typography sx={{ minWidth: 24, color: service?.value ? 'text.primary' : 'text.secondary' }}>
        {{ true: 'Yes', false: 'No' }[service?.value] ?? '-'}
      </Typography>
      {service?.info && <Typography sx={{ color: 'text.secondary', wordBreak: 'break-word' }}>{service.info}</Typography>}
    </Stack>
  )
}
